var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-infopage-slider-item",class:'_type_' + _vm.type},[_c('div',{staticClass:"plugin-infopage-slider-item__content",style:(_vm.style)},[_vm._t("default")],2),(_vm.url)?_c('common-customizable-link',{staticClass:"plugin-infopage-slider-item__overlay",attrs:{"href":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }